export const FIND_ASSIGNABLE_FILE_ADDONS = `
  query FindAssignableAddonsForFile($filter: FindAssignableFileAddonsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    media {
      findAssignableAddonsForFile(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name }
      }
    }
  }
`;
